export { default as SocketProvider } from './components/SocketProvider/SocketProvider';
export { default as SocketEmitter } from './services/SocketEmitter';
export { default as socket } from './services/socket';

const url = process.env.VUE_APP_WS_URL;
export const getSocketConnectionData = (token, application = 'api') => ({
    url,
    params: {
        application,
        token
    }
});
